import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

export interface RangesData {
  discountPercentage?: number
  id: number
  price: number
  range: string
  rangeEnd?: number
  rangeStart: number
}

export const useGetDiscountRanges = (
  volumePrices: VolumeBasedPriceV1[] = [],
): RangesData[] => {
  const sortedVolumePrices = volumePrices.toSorted(
    (firstPrice, secondPrice) =>
      (firstPrice.quantityThreshold ?? 0) -
      (secondPrice.quantityThreshold ?? 0),
  )

  return sortedVolumePrices.map((discount, index) => {
    const rangeStart = discount.quantityThreshold ?? 0
    const nextDiscount =
      index + 1 < sortedVolumePrices.length
        ? sortedVolumePrices[index + 1]
        : undefined
    const rangeEnd = nextDiscount?.quantityThreshold
      ? nextDiscount.quantityThreshold - 1
      : undefined
    const discountPercentage = discount.discountPercentage ?? 0
    const range =
      rangeEnd && rangeStart !== rangeEnd
        ? `${rangeStart}-${rangeEnd}`
        : String(rangeStart)
    const price =
      index === 0 && discount.unitDiscountPrice
        ? discount.unitDiscountPrice
        : (discount.unitOriginPrice ?? 0)

    return {
      discountPercentage,
      id: index,
      price,
      range,
      rangeEnd,
      rangeStart,
    }
  })
}
